
export type ExploreContentResponsePageAllOfThreeContentItemBasicInfoAllOfTwoType = typeof ExploreContentResponsePageAllOfThreeContentItemBasicInfoAllOfTwoType[keyof typeof ExploreContentResponsePageAllOfThreeContentItemBasicInfoAllOfTwoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExploreContentResponsePageAllOfThreeContentItemBasicInfoAllOfTwoType = {
  TWEET: 'TWEET',
  TOPIC: 'TOPIC',
  PROJECT: 'PROJECT',
} as const;
